import AttributeValueDisplay from "@/components/AttributeValueDisplay"
import ColorDisplay from "@/components/Color/ColorDisplay"

export const columns = [
  {
    header: "Name",
    accessorKey: "key",
  },
  {
    header: "Attribute",
    accessorKey: "attribute",
  },
  {
    header: "Value",
    cell: ({ row }) => <AttributeValueDisplay value={row.original.value} />,
  },
]
